/* CF BUNDLES - erstatning for Kaching Bundles (Claude 25/9-2026). Se snippets/cf-bundles.liquid. */
(() => {
  if (customElements.get('cf-bundles')) return;
  const esc = v => String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const LOCALE = {dk:'da-DK', se:'sv-SE', no:'nb-NO'};

  class CFBundles extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.selected = Math.min(this.config.selected || 0, this.config.offers.length - 1);
      this.render();
      this.syncSticky();
      this.controller = new AbortController();
      const opt = {signal: this.controller.signal};
      this.addEventListener('click', e => {
        const c = e.target.closest('[data-choice]');
        if (c) this.select(Number(c.dataset.choice));
      }, opt);
      this.addEventListener('keydown', e => {
        if (!['ArrowDown','ArrowUp','ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const n = this.config.offers.length;
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : (this.selected + (['ArrowDown','ArrowRight'].includes(e.key) ? 1 : -1) + n) % n;
        this.select(next);
        this.querySelector(`[data-choice="${next}"]`).focus();
      }, opt);
      /* Koebsknappen (og sticky-knappen, som klikker paa den) fanges foer temaet/UpCart laegger 1 stk i kurven. */
      this.form.addEventListener('submit', e => this.submit(e), {...opt, capture: true});
      window.addEventListener('click', e => {
        const btn = e.target.closest?.('button[type="submit"],input[type="submit"]');
        if (btn?.form === this.form) this.submit(e);
      }, {...opt, capture: true});
    }
    disconnectedCallback() { this.controller?.abort(); this.initialized = false; }

    money(cents) {
      const loc = LOCALE[this.config.market] || 'da-DK';
      return new Intl.NumberFormat(loc, {maximumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100) + ' kr';
    }

    priceHTML(p, was) {
      return `<span class="cf-bundle__price kaching-bundles__bar-price">${this.money(p)}</span>` +
        (was > p ? `<s class="cf-bundle__compare kaching-bundles__bar-full-price">${this.money(was)}</s>` : '');
    }

    render() {
      const c = this.config;
      const pkg = this.dataset.kind === 'package';
      this.querySelector('[data-choices]').innerHTML = c.offers.map((o, i) => {
        const on = i === this.selected;
        const lead = o.image
          ? `<img class="cf-bundle__image" src="${esc(o.image)}" alt="" width="48" height="48" loading="lazy">`
          : `<span class="cf-bundle__radio" aria-hidden="true"></span>`;
        const tiles = o.products ? `<span class="cf-bundle__products">${o.products.map((p, j) =>
          `${j ? '<span class="cf-bundle__plus" aria-hidden="true"><span>+</span></span>' : ''}` +
          `<span class="cf-bundle__product"><img src="${esc(p.image)}" alt="" width="50" height="50" loading="lazy"><span>${esc(p.title)}</span>` +
          (o.tilePrices ? `<span class="cf-bundle__product-price">${this.money(p.price)}${p.compare > p.price ? `<s>${this.money(p.compare)}</s>` : ''}</span>` : '') +
          `</span>`).join('')}</span>` : '';
        const gift = o.gift ? `<span class="cf-bundle__gift"><img src="${esc(o.gift.image)}" alt="" width="30" height="30" loading="lazy"><span>${esc(o.gift.title)}</span>${o.gift.compare ? `<s>${this.money(o.gift.compare)}</s>` : ''}</span>` : '';
        return `<button type="button" role="radio" aria-checked="${on}" tabindex="${on ? 0 : -1}" ` +
          `class="cf-bundle kaching-bundles__bar${on ? ' kaching-bundles__bar--selected' : ''}${o.badge ? ' cf-bundle--badge' : ''}" data-choice="${i}">` +
          (o.badge ? `<span class="cf-bundle__badge">${esc(o.badge)}</span>` : '') +
          `<span class="cf-bundle__wrap"><span class="cf-bundle__main">${lead}<span class="cf-bundle__content">` +
          `<span class="cf-bundle__text"><span class="cf-bundle__title">${esc(o.title)}</span>` +
          (o.subtitle ? `<span class="cf-bundle__subtitle">${esc(o.subtitle)}</span>` : '') +
          `</span><span class="cf-bundle__pricing">${this.priceHTML(o.price, o.compare)}</span></span></span>${tiles}</span>${gift}</button>`;
      }).join('');
      this.classList.toggle('cf-bundles--package', pkg);
    }

    select(index) {
      this.selected = index;
      const err = this.querySelector('[role="alert"]');
      err.hidden = true; err.textContent = '';
      this.querySelectorAll('[data-choice]').forEach((el, i) => {
        const on = i === index;
        el.setAttribute('aria-checked', String(on));
        el.tabIndex = on ? 0 : -1;
        el.classList.toggle('kaching-bundles__bar--selected', on);
      });
      this.syncSticky();
      this.dispatchEvent(new CustomEvent('cf-bundles:change', {bubbles: true, detail: this.config.offers[index]}));
    }

    /* Sticky-baren viser den valgte pakkes pris. */
    syncSticky() {
      const o = this.config.offers[this.selected];
      document.querySelectorAll('#cfSticky .cf-sticky__price').forEach(box => {
        const now = box.querySelector('.now');
        if (now) now.textContent = this.money(o.price);
        let was = box.querySelector('.was');
        if (o.compare > o.price) {
          if (!was) { was = document.createElement('span'); was.className = 'was'; box.appendChild(was); }
          was.textContent = this.money(o.compare); was.hidden = false;
        } else if (was) { was.hidden = true; }
      });
    }

    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      const offer = this.config.offers[this.selected];
      const err = this.querySelector('[role="alert"]');
      err.hidden = true;
      const btn = this.form.querySelector('[type="submit"]');
      if (btn?.disabled || btn?.getAttribute('aria-disabled') === 'true') return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      btn?.setAttribute('aria-disabled', 'true');
      btn?.classList.add('loading');
      this.form.querySelector('.loading__spinner')?.classList.remove('hidden');
      const root = window.Shopify?.routes?.root || '/';
      try {
        const fd = new FormData(this.form);
        const props = {};
        for (const [k, v] of fd) { const m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; }
        /* Omvendt raekkefoelge: Shopify viser senest tilfoejede foerst, saa maskinen staar oeverst i kurven. */
        const items = offer.items.map(it => ({id: it.id, quantity: it.quantity, properties: {...props, _cf_bundle: offer.key}})).reverse();
        const res = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || this.config.error);
        if (typeof window.upcartRefreshCart === 'function' && typeof window.upcartOpenCart === 'function') {
          try { await window.upcartRefreshCart(); await window.upcartOpenCart(); }
          catch { window.location.assign(root + 'cart'); }
        } else {
          window.location.assign(root + 'cart');
        }
      } catch (f) {
        err.textContent = f.message || this.config.error;
        err.hidden = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        btn?.removeAttribute('aria-disabled');
        btn?.classList.remove('loading');
        this.form.querySelector('.loading__spinner')?.classList.add('hidden');
      }
    }
  }
  customElements.define('cf-bundles', CFBundles);
})();
